import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material";


const ButtonCustom = ({ boldDisabled, label, width,fontSize, borderRadius,variant, onClick, color, background,size, disabled, disableRipple = false, className }) => {

  const CustomButton = styled(Button)(({ theme,variant }) => ({
    fontWeight: boldDisabled ? "normal" : "bold" ,  
    color: color ? color :"#00A88F",
    borderRadius: borderRadius ? `${borderRadius}rem` : "none",
    fontSize: fontSize ? fontSize : "",
    background: background ? background : "",
    width: width ? width : "",
    textTransform: "none",
    borderColor : "#263057",
  
}));


  return (
    <CustomButton onClick={onClick}  disabled={disabled} variant={variant ? variant : ""}  size={ size ? size : "small"} className={className} disableRipple={disableRipple}>
      {label}
    </CustomButton>
  );
};

export default ButtonCustom;
